import { useMutation } from '@tanstack/react-query';
import type { AssistantAnswerDto } from '@app/shared';
import { api } from '../../lib/api';

/** One question to the AI Assistant. It reads only, so nothing is invalidated. */
export const useAskAssistant = () =>
  useMutation({
    mutationFn: (question: string) => api.post<AssistantAnswerDto>('/assistant/ask', { question }),
  });
